export enum MlInputSourceLabel {
  'PI' = 'pi',
  'PDMS' = 'pdms',
  'PI then PDMS' = 'pi_first',
  'PDMS then PI' = 'pdms_first',
}
